import { render, staticRenderFns } from "./listProfilbmtk.vue?vue&type=template&id=01eb7062"
import script from "./listProfilbmtk.vue?vue&type=script&lang=js"
export * from "./listProfilbmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports